export default __webpack_public_path__ + "static/not-found-b51f9bb843d775725b27d172ffc98533.png";